import { createRouter, createWebHistory } from 'vue-router'
import StartPage from '../views/StartPage.vue'
import QuizPage from '../views/QuizPage.vue'
import DeveloperPage from '../views/DeveloperPage.vue'
import ResourcesPage from '@/components/ResourcesPage.vue'

const routes = [
  {
    path: '/',
    name: 'DeveloperPage',   // اجعل الصفحة الرئيسية هي DeveloperPage
    component: DeveloperPage
  },

  { path: '/resources', component: ResourcesPage },

  {
    path: '/quiz',
    name: 'QuizPage',
    component: QuizPage,
    props: route => ({ activated: route.query.activated === 'true' })
  },
  {
    path: '/start',
    name: 'StartPage',       // إذا أردت الاحتفاظ بصفحة البداية القديمة في مسار آخر
    component: StartPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
